import React from "react";
import { InputField } from "../../../../components/controls/InputField";
import { SelectPicker, Checkbox } from "rsuite";
import "./../../payout.scss";
import "./../payout/styles/payoutRecipients.scss";
import achievementTypes from "../../../dev/data/achievementTypes";
import payoutRoles from "../../../dev/data/payoutRoles";
import { faFlag, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import triangle from "./assets/triangle_icon.jpg";
import _ from "lodash";
import moment from "moment/moment";

export default function TeacherTableRows({
  data,
  columns,
  rows,
  isComplete = false,
  payoutAchievementTypes,
  handleOnChange,
  appUserMgr,
  handleOnCheckBox,
}) {
  const dataRows = _.orderBy(data, ["EligiblePayee"], ["asc"])?.map(
    (dataRecord, i) => {
      //If CompletedDate < UpdatedDate, then show the flag
      const flagIcon =
        moment(dataRecord.CompletedDate).format("YYYY-MM-DDTHH:mm") <
        moment(dataRecord.UpdatedDate).format("YYYY-MM-DDTHH:mm") ? (
          <FontAwesomeIcon icon={faFlag} className="flag-icon" />
        ) : null;

      const minObsIndicator =
        dataRecord["HasMinimumObservation"] === false ? true : false;

      const columnsElements = columns.map((col, colIndex) => {
        let dataRowValue = dataRecord[col.dataProp];

        let colElement;
        if (col.dataProp === "EligiblePayee") {
          dataRowValue = dataRecord["IsUserActive"]
            ? dataRowValue
            : dataRowValue + " (inactive)";
          colElement = (
            <>
              {flagIcon}
              <div className="col-name" title={dataRowValue}>
                {dataRowValue}{" "}
                {minObsIndicator ? (
                  <FontAwesomeIcon
                    icon={faCircleExclamation}
                    className="obs-icon"
                  />
                ) : (
                  ""
                )}
              </div>
            </>
          );
        } else if (
          col.dataProp === "PayoutRoleId" ||
          col.dataProp === "PayoutAchievementTypeId"
        ) {
          const isPayoutRole = col.dataProp === "PayoutRoleId";
          const data = isPayoutRole
            ? payoutRoles
            : payoutAchievementTypes?.map((x) => ({
                value: x.Id,
                label: x.Name,
              }));

          if (
            col.dataProp === "PayoutAchievementTypeId" &&
            !rows.find((x) => x.Id === dataRecord.Id)["IsApplyValueAddedScore"]
          ) {
            colElement = null; // hide the picker if valueAddedScore is not checked
          } else {
            colElement = (
              <SelectPicker
                id={`${dataRecord.Id}+${colIndex}`}
                className="dropdown-is-changed"
                data={data}
                searchable={false}
                readOnly={isComplete}
                onChange={(e) => {
                  handleOnChange(dataRecord.Id, e, col.dataProp);
                }}
                value={rows.find((x) => x.Id === dataRecord.Id)[col.dataProp]}
              />
            );
          }
        } else if (
          col.dataProp === "ValueAddedScore" &&
          !rows.find((x) => x.Id === dataRecord.Id)["IsApplyValueAddedScore"]
        ) {
          colElement = null; // hide the picker if valueAddedScore is not checked
        } else if (
          col.dataProp === "CompassEquiv" ||
          col.dataProp === "SurveyScore" ||
          col.dataProp === "PayoutPct" ||
          col.dataProp === "ValueAddedScore" ||
          col.dataProp === "Comment"
        ) {
          let originalValue =
            _.isNumber(dataRecord[`Original${col.dataProp}`]) &&
            dataRecord[`Original${col.dataProp}`] < 0
              ? null
              : dataRecord[`Original${col.dataProp}`];
          const isChangedInputIcon = (
            <img
              src={triangle}
              alt="Changed Icon"
              className="is-changed-input-icon"
            />
          );
          let currentValue = rows.find((x) => x.Id === dataRecord.Id)[
            col.dataProp
          ];

          let displayValue = currentValue;

          if (col.dataProp === "PayoutPct" && currentValue === 100) {
            displayValue = ""; // Set to blank if PayoutPct and value is 100
          } else if (_.isNil(currentValue)) {
            displayValue = originalValue;
          } else if (_.isNumber(currentValue) && currentValue < 0) {
            displayValue = null;
          } else {
            displayValue = currentValue.toString();
          }

          colElement = (
            <>
              <div className="tooltip-container">
                <InputField
                  id={`${dataRecord.Id}+${colIndex}`}
                  disableError={true}
                  isDisabled={
                    (col.dataProp === "SKRScore" && _.isNil(originalValue)) ||
                    col.dataProp === "CompassEquiv" ||
                    (col.dataProp === "SurveyScore" &&
                      _.isNil(originalValue)) ||
                    isComplete
                  }
                  type={col.dataProp === "Comment" ? "text" : "number"}
                  value={displayValue}
                  onChange={(e) => {
                    handleOnChange(dataRecord.Id, e, col.dataProp);
                  }}
                />
                {rows.find((x) => x.Id === dataRecord.Id)[col.dataProp] !=
                  originalValue &&
                  !_.isNil(originalValue) &&
                  originalValue > 0 && (
                    <div className="tooltip">{originalValue}</div>
                  )}
                {rows.find((x) => x.Id === dataRecord.Id)[col.dataProp] !=
                  originalValue &&
                  !_.isNil(originalValue) &&
                  originalValue > 0 &&
                  isChangedInputIcon}
              </div>
            </>
          );
        } else if (col.dataProp === "SKRScore") {
          let showSkrScore = true;
            // dataRecord["HasMinimumObservation"] === false &&
            // appUserMgr?.AppUserState?.userProfile?.Roles?.some(
            //   (x) => x == "SysAdmin" || x == "NIETAdmin"
            // )
            //   ? true
            //   : dataRecord["HasMinimumObservation"] === true
            //     ? true
            //     : false;

          let originalValue =
            _.isNumber(dataRecord[`Original${col.dataProp}`]) &&
            dataRecord[`Original${col.dataProp}`] < 0
              ? null
              : dataRecord[`Original${col.dataProp}`];
          const isChangedInputIcon = (
            <img
              src={triangle}
              alt="Changed Icon"
              className="is-changed-input-icon"
            />
          );
          let currentValue = rows.find((x) => x.Id === dataRecord.Id)[
            col.dataProp
          ];

          const inputValue =
            _.isNil(currentValue) || !showSkrScore
              ? null
              : _.isNumber(currentValue) && currentValue < 0
                ? null
                : currentValue.toString();

          const isDisabled = _.isNil(originalValue) || !showSkrScore;

          colElement = (
            <>
              <div className="tooltip-container">
                <InputField
                  id={`${dataRecord.Id}+${colIndex}`}
                  disableError={true}
                  isDisabled={isDisabled || isComplete}
                  type={"number"}
                  value={inputValue}
                  onChange={(e) => {
                    handleOnChange(dataRecord.Id, e, col.dataProp);
                  }}
                />
                {rows.find((x) => x.Id === dataRecord.Id)[col.dataProp] !=
                  originalValue &&
                  !_.isNil(originalValue) &&
                  originalValue > 0 && (
                    <div className="tooltip">{originalValue}</div>
                  )}
                {rows.find((x) => x.Id === dataRecord.Id)[col.dataProp] !=
                  originalValue &&
                  !_.isNil(originalValue) &&
                  originalValue > 0 &&
                  isChangedInputIcon}
              </div>
            </>
          );
        } else if (
          col.dataProp === "IsExclude" ||
          col.dataProp === "IsHardToFill" ||
          col.dataProp === "IsApplyValueAddedScore"
        ) {
          colElement = (
            <>
              <Checkbox
                id={`${dataRecord.Id}+${colIndex}`}
                checked={
                  col.dataProp === "IsExclude"
                    ? !rows.find((x) => x.Id === dataRecord.Id)["IsActive"]
                    : rows.find((x) => x.Id === dataRecord.Id)[col.dataProp]
                }
                disabled={isComplete}
                onChange={() => handleOnCheckBox(dataRecord.Id, col.dataProp)}
              />

              {/* {col.dataProp === 'IsExclude' ? rows.find(x => x.Id === dataRecord.Id)["IsActive"] != dataRecord['OriginalIsActive'] && isChangedIcon
                                :
                                rows.find(x => x.Id === dataRecord.Id)[col.dataProp] != dataRecord['Original' + col.dataProp] && !_.isNil(dataRecord['Original' + col.dataProp]) && isChangedIcon} */}
            </>
          );
        } else {
          colElement = <div>{dataRowValue}</div>;
        }

        return (
          <div
            key={`${col.header}_${dataRowValue}`}
            style={{ width: col.width }}
            className={`col ${col.boldText ? "bold-text" : ""} ${
              col.lastCol ? "last-col" : ""
            } ${col.isBool ? "center-item" : ""} ${
              col.centerInput ? "center-input" : ""
            }`}
          >
            {colElement}
          </div>
        );
      });

      return (
        <div key={i} className="data-row">
          {columnsElements}
        </div>
      );
    }
  );

  return <div className="row-area">{dataRows}</div>;
}
